import { render } from "./BaseContentWrapper.vue?vue&type=template&id=2f973891"
import script from "./BaseContentWrapper.vue?vue&type=script&lang=js"
export * from "./BaseContentWrapper.vue?vue&type=script&lang=js"

import "./BaseContentWrapper.vue?vue&type=style&index=0&id=2f973891&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__